import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Grid } from 'components/Grid'
import Button from 'components/Button'
import Icon from 'components/Icon'
import messages from './messages'
import { parseCSVtoJson } from './utils'
import { createUsersBulk } from 'store/organizations'
import { addAlert } from 'store/global'
import styles from './ActionsGrid.scss'

const COLUMN_ACTIONS = 'actions'

export default function ActionsGrid(props) {
  const dispatch = useDispatch()
  const {
    isLoading = false,
    type,
    header,
    onAction = () => {},
    reverseRows = false,
    rows = [],
    columns,
    children: renderCell,
    onExportCSV = () => {},
    showCreateButton = true,
  } = props

  const uploadInput = useRef(null)

  const renderActionsCell = row => (
    <>
      <Button onClick={() => onAction('edit', row)}>
        <Icon name='edit' size='regular'>
          <FormattedMessage {...messages.actions.edit} />
        </Icon>
      </Button>
      <Button buttonType='secondary' onClick={() => onAction('delete', row)}>
        <Icon name='delete' size='regular'>
          <FormattedMessage {...messages.actions.delete} />
        </Icon>
      </Button>
    </>
  )

  const displayedRows = reverseRows ? [...rows].reverse() : rows

  const handleFileUpload = async e => {
    const file = e.target.files[0]

    if (file) {
      const reader = new FileReader()

      reader.onload = async event => {
        const csvData = event.target.result
        const users = await parseCSVtoJson(csvData)

        try {
          await dispatch(createUsersBulk({ users }))
          dispatch(addAlert({ type: 'success', message: 'Users was added successfully' }))
        } catch (e) {
          dispatch(addAlert({ type: 'danger', message: 'Create users bulk error' }))
        }
      }

      reader.readAsText(file)
    }
  }

  return (
    <div className={styles.container}>
      <header className='page-header'>
        <h1 className={cx('page-title', 'h1')}>{header}</h1>
        <section className={styles.pageActions}>
          {showCreateButton && (
            <Button color='primary' onClick={() => onAction('create')}>
              <Icon name='create' size='regular'>
                <FormattedMessage {...messages.actions.create} values={{ type }} tagName='span' />
              </Icon>
            </Button>
          )}
          {/* <Button color='primary' onClick={onExportCSV} className={styles.exportCSV}>
            <FormattedMessage {...messages.actions.exportCSV} />
          </Button> */}
          {/* <Button color='primary' onClick={() => uploadInput?.current?.click()} className={styles.uploadCSV}>
            <FormattedMessage {...messages.actions.createByCSV} values={{ type }} tagName='span' />
            <input
              ref={uploadInput}
              type='file'
              style={{ display: 'none' }}
              multiple={false}
              accept='.csv'
              onChange={handleFileUpload}
            />
          </Button> */}
          {/* <Button color='primary' onClick={downloadCSVExample} className={styles.uploadCSV}>
            <FormattedMessage {...messages.actions.example} />
          </Button> */}
        </section>
      </header>
      <div className={styles.content}>
        <Grid
          isLoading={isLoading}
          withHeaders
          fixedRowCount={1}
          maxHeight={650}
          rows={displayedRows}
          columns={columns}
          className={styles.grid}
          innerClassName={styles.gridInner}
        >
          {(row, column, rowIndex, isHeader = false) => {
            if (isHeader) return <h3 className={styles.headerCell}>{renderCell(row, column.key, true)}</h3>

            return (
              <div
                onClick={column.key === COLUMN_ACTIONS ? null : () => onAction('view', row)}
                className={cx(styles.cell, styles[column.key])}
              >
                {renderCell(row, column.key, false)}
              </div>
            )
          }}
        </Grid>
      </div>
    </div>
  )
}

ActionsGrid.propTypes = {
  isLoading: PropTypes.bool,
  type: PropTypes.string.isRequired,
  header: PropTypes.any,
  onAction: PropTypes.func,
  reverseRows: PropTypes.bool,
  rows: PropTypes.array,
  columns: PropTypes.array.isRequired,
  children: PropTypes.func.isRequired,
  onExportCSV: PropTypes.func.isRequired,
  showCreateButton: PropTypes.bool,
}